import styled from 'styled-components';
import { ScLogo } from '../../components/Logo/styled';
import { fluidScale, fpx } from '../../styles/fluid';

export const halloweenScale = fluidScale({
  desktopWidth: 1280,
  desktopHeight: 720,
  mobileWidth: 376,
  mobileHeight: 720,
});

export const ScRoot = styled.div`
  ${halloweenScale};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  background-color: #000;
  font-family: "Work Sans", sans-serif;
`;

export const ScHeroBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - ${fpx(720 - 518)});
  overflow: hidden;
  pointer-events: none;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .mobile {
    display: none;
  }

  @media (orientation: portrait) {
    height: ${fpx(670)};

    .desktop {
      display: none;
    }

    .mobile {
      display: block;
    }
  }
`;

export const ScCanvas = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: ${fpx(1280)};
  min-height: 100vh;
  min-height: 100dvh;
  --hero-shift: max(0px, (100vh - ${fpx(720)}) / 2);
  --hero-shift: max(0px, (100dvh - ${fpx(720)}) / 2);

  @media (orientation: portrait) {
    width: ${fpx(376)};
    min-height: 0;
    --hero-shift: 0px;
    padding-bottom: ${fpx(40)};
  }
`;

export const ScHero = styled.div`
  position: relative;
  flex-grow: 1;
  flex-shrink: 0;
  width: 100%;
  min-height: ${fpx(450)};

  @media (orientation: portrait) {
    flex-grow: 0;
    height: ${fpx(670)};
  }
`;

export const ScLogoWrap = styled.div`
  position: absolute;
  z-index: 3;
  top: ${fpx(24)};
  left: 50%;
  transform: translateX(-50%);

  ${ScLogo} img {
    display: block;
    width: ${fpx(152)};
    height: ${fpx(40)};
  }

  @media (orientation: portrait) {
    top: ${fpx(16)};
    margin-left: ${fpx(0.5)};

    ${ScLogo} img {
      width: ${fpx(121)};
      height: ${fpx(32)};
    }
  }
`;

export const ScCharacter = styled.div`
  position: absolute;
  z-index: 1;
  top: calc(${fpx(-44)} + var(--hero-shift));
  left: ${fpx(727)};
  width: ${fpx(290)};
  height: ${fpx(311)};
  pointer-events: none;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (orientation: portrait) {
    top: ${fpx(70)};
    left: ${fpx(69)};
    width: ${fpx(247)};
    height: ${fpx(281)};
  }
`;

export const ScPromoCardPosition = styled.div`
  position: absolute;
  z-index: 2;
  top: calc(${fpx(83)} + var(--hero-shift));
  left: ${fpx(130)};

  @media (orientation: portrait) {
    top: ${fpx(317)};
    left: ${fpx(50)};
  }
`;
